export default "__VITE_ASSET__31fa5522__"